/** 来源：foodbuy/market Panel；Card 为规范名，Panel/PanelHeading 作为既有轻量 API 别名保留。 */
import type { HTMLAttributes, ReactNode } from 'react'

export type CardProps = HTMLAttributes<HTMLElement> & { children?: ReactNode; padded?: boolean }

export function Card({ children, className = '', padded = false, ...props }: CardProps) {
  return (
    <section
      className={`panel overflow-hidden rounded-[var(--radius-lg)] border border-[var(--color-line)] bg-[var(--color-panel)] shadow-[var(--shadow-sm)] ${padded ? 'p-4 sm:p-5' : ''} ${className}`.trim()}
      {...props}
    >
      {children}
    </section>
  )
}

export function CardHeading({ title, description, action }: { title: ReactNode; description?: ReactNode; action?: ReactNode }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3 border-b border-[var(--color-line)] px-5 py-3">
      <div>
        <h2 className="m-0 text-base font-semibold text-[var(--color-ink)]">{title}</h2>
        {description ? <p className="m-0 mt-1 text-xs leading-5 text-[var(--color-muted)]">{description}</p> : null}
      </div>
      {action}
    </div>
  )
}

export const Panel = Card
export const PanelHeading = CardHeading
